import React, { Component } from "react";
import NumberFormat from "react-number-format";
import Time from "react-time-format";
import { connect } from "react-redux";
import { change_Lang } from "../../../actions/Helper_action";
import n2wordsEN from "n2words/lib/i18n/EN.mjs";
class RentPrintEnglish extends Component {
 render() {
  const {
   lang,
   change_Lang,
   rent_invoice_obj,
   index_rentcontrct,
   user,
   primary_logo,
   footer_logo,
   name_en,
   thirdcolor,
  } = this.props;
  // English
  let converter1 =
   rent_invoice_obj.introduction &&
   n2wordsEN(
    parseFloat(rent_invoice_obj.introduction.toString().replace(/,/g, ""))
   );
  let converter2 =
   rent_invoice_obj.paymentmonth &&
   n2wordsEN(
    parseFloat(rent_invoice_obj.paymentmonth.toString().replace(/,/g, ""))
   );
  let converter3 =
   rent_invoice_obj.feelate &&
   n2wordsEN(parseFloat(rent_invoice_obj.feelate.toString().replace(/,/g, "")));
  let converter4 =
   rent_invoice_obj.safly &&
   n2wordsEN(parseFloat(rent_invoice_obj.safly.toString().replace(/,/g, "")));
  let converter5 =
   rent_invoice_obj.fee &&
   n2wordsEN(parseFloat(rent_invoice_obj.fee.toString().replace(/,/g, "")));
  var curr = new Date();
  curr.setDate(curr.getDate());
  let today = curr.toISOString().substr(0, 10);
  return (
   <>
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <div>
     <div className="row">
      <div className="col-12">
       <div className="conn">
        <div class="row">
         <div class="col-4">
          <p
           style={{
            fontSize: "22px",
            color: "#000",
            textAlign: "left",
            fontWeight: "bold",
           }}
           class=" text-uppercase"
          >
           &nbsp;&nbsp;{change_Lang("date")} &nbsp;:&nbsp;
           <Time
            value={rent_invoice_obj.createdAt}
            format="YYYY-MM-DD"
            style={{
             fontSize: "22px",
             color: "#000",
             fontWeight: "bold",
            }}
           />
          </p>
         </div>
         <div class="col-4 d-flex justify-content-center">
          <p
           style={{
            fontSize: "25px",
            color: "#000",
            fontWeight: "bolder",
           }}
           class={`d-flex justify-content-center text-uppercase  `}
          >
           ({change_Lang("Rental contract")})
          </p>
         </div>
         <div class="col-4 text-right">
          <p
           style={{
            fontSize: "22px",
            color: "#000",
            fontWeight: "bold",
           }}
           class=" text-uppercase"
          >
           {change_Lang("contract number")} #&nbsp;
           {index_rentcontrct}&nbsp;
          </p>
         </div>
        </div>
        <div class="row">
         <div class="col-12">
          <div class="form-group row form-inline">
           <label
            style={{
             fontSize: "23px",
             color: "black",
             fontWeight: "bolder",
            }}
            class="col-sm-3 col-form-label d-flex justify-content-start fkk"
           >
            First party (owner) :
           </label>
           <div class="col-sm-3">
            <label
             class="d-flex justify-content-start"
             style={{ fontWeight: "bold", fontSize: "22px" }}
            >
             {rent_invoice_obj.firstname}
            </label>
           </div>
           <label
            style={{
             fontSize: "25px",
             color: "black",
             fontWeight: "bold",
            }}
            class="col-sm-3 col-form-label fkk d-flex justify-content-start"
           >
            Second party (tenant) :
           </label>
           <div class="col-sm-3">
            <label
             class="d-flex justify-content-start"
             style={{ fontWeight: "bold", fontSize: "22px" }}
            >
             {rent_invoice_obj.tenantId && rent_invoice_obj.tenantId.secondname}
            </label>
           </div>
           <label
            style={{
             fontSize: "25px",
             color: "black",
             fontWeight: "bold",
            }}
            class="col-sm-3 col-form-label fkk d-flex justify-content-start"
           >
            {" "}
            {change_Lang("first_rule_place")}:
           </label>
           <br />
           <div class="col-sm-3">
            <label
             class="d-flex justify-content-start"
             style={{ fontWeight: "bold", fontSize: "22px" }}
            >
             {rent_invoice_obj.available_id &&
              rent_invoice_obj.available_id.Place_ku}
            </label>
           </div>

           <label
            style={{
             fontSize: "25px",
             color: "black",
             fontWeight: "bold",
            }}
            class="col-sm-3 col-form-label fkk d-flex justify-content-start"
           >
            {change_Lang("Type of property")}:
           </label>
           <div class="col-sm-3">
            <label
             class="d-flex justify-content-start"
             style={{ fontWeight: "bold", fontSize: "22px" }}
            >
             {change_Lang(
              rent_invoice_obj.available_id &&
               rent_invoice_obj.available_id.Property
             )}
            </label>
           </div>
           {/* Area */}
           <label
            style={{
             fontSize: "25px",
             color: "black",
             fontWeight: "bold",
            }}
            class="col-sm-3 col-form-label fkk d-flex justify-content-start"
           >
            {" "}
            {change_Lang("Number of property")}:
           </label>

           <div class="col-sm-3">
            <label
             class="d-flex justify-content-start"
             style={{ fontWeight: "bold", fontSize: "22px" }}
            >
             {rent_invoice_obj.available_id &&
              rent_invoice_obj.available_id.NOoFProperty}
            </label>
           </div>

           <label
            style={{
             fontSize: "25px",
             color: "black",
             fontWeight: "bold",
            }}
            class="col-sm-3 col-form-label fkk d-flex justify-content-start"
           >
            {change_Lang("Area")}:
           </label>
           <div class="col-sm-3">
            <label
             class="d-flex justify-content-start"
             style={{ fontWeight: "bold", fontSize: "22px" }}
            >
             {rent_invoice_obj.available_id &&
              rent_invoice_obj.available_id.Area}
             &nbsp;م<sup>2</sup>
            </label>
           </div>
          </div>
          <p
           style={{
            fontSize: "24px",
            color: "#000",
            backgroundColor: "#ebebeb",
            borderRadius: "0px 50px 0px 0px",
            fontWeight: "bold",
           }}
           class="my-2 d-flex justify-content-center"
          >
           {change_Lang("agreement")}
          </p>
         </div>
        </div>
        <div className="row">
         <div className="col-12">
          <table className="table">
           <tbody>
            <tr
             style={{
              fontSize: `${
               lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
              }`,
             }}
             className="p-0 m-0"
            >
             <th
              className={`${lang !== "en" ? "fkp" : "fkp"}`}
              scope="row"
              style={{
               color: `${thirdcolor}`,
               borderTop: "none",
              }}
             >
              -
             </th>
             <td
              style={{
               lineHeight: "1.3",
               wordSpacing: "3px",
               color: "black",

               fontSize: "23px",
               textAlign: "justify",
               borderTop: "none",
              }}
             >
              According to the needs of the Second Party a residential unit for
              residential purposes, and according to the First Party is the
              landlord of the unit and intends to rent it, both parties agreed
              to sign the tenancy agreement and agreed on the following points
              and terms:
             </td>
            </tr>
            <tr
             style={{
              fontSize: `${
               lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
              }`,
             }}
             className="p-0 m-0"
            >
             <th
              className={`${lang !== "en" ? "fkp" : "fkp"}`}
              scope="row"
              style={{
               color: `${thirdcolor}`,
               borderTop: "none",
              }}
             >
              1-
             </th>
             <td
              style={{
               lineHeight: "1.3",
               wordSpacing: "2px",
               color: "black",

               fontSize: "23px",
               textAlign: "justify",
               borderTop: "none",
              }}
             >
              The First Party agrees to rent the above property to the Second
              Party for a period of (
              {Math.floor(Number(rent_invoice_obj.rental) / 12)}) years from (
              <Time
               value={rent_invoice_obj.startdate}
               format="YYYY-MM-DD"
               style={{
                color: "black",
               }}
              />
              ) to (
              <Time
               value={rent_invoice_obj.enddate}
               format="YYYY-MM-DD"
               style={{
                color: "black",
               }}
              />
              ) where both parties agree on the amount of the rent which is
              (&nbsp;
              <NumberFormat
               displayType="text"
               thousandSeparator={true}
               value={rent_invoice_obj.paymentmonth}
               style={{}}
               className="text-center"
               prefix={`${rent_invoice_obj.currency === "dolar" ? "$" : "ID"}`}
              />
              &nbsp;
              {converter2}&nbsp;
              {lang === "en" && rent_invoice_obj.currency === "dolar"
               ? "(USD)"
               : lang === "krd" && rent_invoice_obj.currency === "dolar"
               ? "(دۆلار)"
               : lang === "arb" && rent_invoice_obj.currency === "dolar"
               ? "(دولار)"
               : lang === "en" && rent_invoice_obj.currency !== "dolar"
               ? "(IQD)"
               : lang === "krd" && rent_invoice_obj.currency !== "dolar"
               ? "(دینار)"
               : lang === "arb" && rent_invoice_obj.currency !== "dolar"
               ? "(دینار)"
               : ""}
              ) for {Math.floor(Number(rent_invoice_obj.rental) / 12)} year .
             </td>
            </tr>
            <tr
             style={{
              fontSize: `${
               lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
              }`,
             }}
            >
             <th
              className={`${lang !== "en" ? "fkp" : "fkp"}`}
              scope="row"
              style={{
               color: `${thirdcolor}`,
               borderTop: "none",
              }}
             >
              2-
             </th>
             <td
              style={{
               lineHeight: "1.3",
               wordSpacing: "2px",
               color: "black",

               fontSize: "23px",
               textAlign: "justify",
               borderTop: "none",
              }}
             >
              The introduction of the agreement is an inseparable part of this
              agreement.
             </td>
            </tr>
            <tr
             style={{
              fontSize: `${
               lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
              }`,
             }}
            >
             <th
              className={`${lang !== "en" ? "fkp" : "fkp"}`}
              scope="row"
              style={{
               color: `${thirdcolor}`,
               borderTop: "none",
              }}
             >
              3-
             </th>
             <td
              style={{
               lineHeight: "1.3",
               wordSpacing: "2px",
               color: "black",

               fontSize: "23px",
               textAlign: "justify",
               borderTop: "none",
              }}
             >
              The Second Party shall pay the amount of ({" "}
              <NumberFormat
               displayType="text"
               thousandSeparator={true}
               value={rent_invoice_obj.introduction}
               style={{}}
               prefix={`${rent_invoice_obj.currency === "dolar" ? "$" : "ID"}`}
               className="text-center"
              />
              &nbsp;
              {converter1}
              {lang === "en" && rent_invoice_obj.currency === "dolar"
               ? "(USD)"
               : lang === "krd" && rent_invoice_obj.currency === "dolar"
               ? "(دۆلار)"
               : lang === "arb" && rent_invoice_obj.currency === "dolar"
               ? "(دولار)"
               : lang === "en" && rent_invoice_obj.currency !== "dolar"
               ? "(IQD)"
               : lang === "krd" && rent_invoice_obj.currency !== "dolar"
               ? "(دینار)"
               : lang === "arb" && rent_invoice_obj.currency !== "dolar"
               ? "(دینار)"
               : ""}
              ) to the First Party as an advance rent for (
              <NumberFormat
               displayType="text"
               thousandSeparator={true}
               value={rent_invoice_obj.Monthintroduction}
               className="text-center"
              />
              ) months then, the Second Party will pay the rent to (DIVINE TIME)
              Company every (
              <NumberFormat
               displayType="text"
               thousandSeparator={true}
               value={rent_invoice_obj.MonthForRent}
               className="text-center"
              />
              )months .
             </td>
            </tr>
            <tr
             style={{
              fontSize: `${
               lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
              }`,
             }}
            >
             <th
              className={`${lang !== "en" ? "fkp" : "fkp"}`}
              scope="row"
              style={{
               color: `${thirdcolor}`,
               borderTop: "none",
              }}
             >
              4-
             </th>
             <td
              style={{
               lineHeight: "1.3",
               wordSpacing: "2px",
               color: "black",

               fontSize: "23px",
               textAlign: "justify",
               borderTop: "none",
              }}
             >
              The Second Party should pay an amount of (
              <NumberFormat
               displayType="text"
               thousandSeparator={true}
               style={{}}
               value={rent_invoice_obj.safly}
               className="text-center"
               prefix={`${rent_invoice_obj.currency === "dolar" ? "$" : "ID"}`}
              />
              &nbsp;
              {converter4}
              {lang === "en" && rent_invoice_obj.currency === "dolar"
               ? "(USD)"
               : lang === "krd" && rent_invoice_obj.currency === "dolar"
               ? "(دۆلار)"
               : lang === "arb" && rent_invoice_obj.currency === "dolar"
               ? "(دولار)"
               : lang === "en" && rent_invoice_obj.currency !== "dolar"
               ? "(IQD)"
               : lang === "krd" && rent_invoice_obj.currency !== "dolar"
               ? "(دینار)"
               : lang === "arb" && rent_invoice_obj.currency !== "dolar"
               ? "(دینار)"
               : ""}
              ) as a deposit at the (DIVINE TIME) company and this amount will
              be returned to the Second Party after the handover of the property
              without any damages and clearance all services, electricity and
              water (government and private for the project) and there should
              not be any damages in the property as it is renting.
             </td>
            </tr>
            <tr
             style={{
              fontSize: `${
               lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
              }`,
             }}
            >
             <th
              className={`${lang !== "en" ? "fkp" : "fkp"}`}
              scope="row"
              style={{
               color: `${thirdcolor}`,
               borderTop: "none",
              }}
             >
              5-
             </th>
             <td
              style={{
               lineHeight: "1.3",
               wordSpacing: "2px",
               color: "black",

               fontSize: "23px",
               textAlign: "justify",
               borderTop: "none",
              }}
             >
              If the tenant (Second Party) wishes to cancel the agreement or
              evacuate the property earlier the first six months before the
              expiration of the agreement, the amount of deposit referred in
              paragraph (forth) shall not be returned until the property is
              rented again and the period of the property remains empty is
              counted and the remaining amount will be returned.
             </td>
            </tr>
            <tr
             style={{
              fontSize: `${
               lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
              }`,
             }}
            >
             <th
              className={`${lang !== "en" ? "fkp" : "fkp"}`}
              scope="row"
              style={{
               color: `${thirdcolor}`,
               borderTop: "none",
              }}
             >
              6-
             </th>
             <td
              style={{
               lineHeight: "1.3",
               wordSpacing: "2px",
               color: "black",

               fontSize: "23px",
               textAlign: "justify",
               borderTop: "none",
              }}
             >
              If the Second Party (tenant) wants to evacuate the property before
              the expiration of the agreement, then she/he should notify the
              landlord (1) one month in advance, Contrary to this clause, the
              rent shall be counted on the Second Party (tenant) of this
              agreement until the property is rented again.
             </td>
            </tr>
           </tbody>
          </table>
         </div>
        </div>
       </div>
       <br />
       <br />
       <br />
       <br />
       <br />
       <br />
       <br />
       <br />
       <div className="conn">
        <div className="row">
         <div className="col-12">
          <table className="table">
           <tbody>
            <tr
             style={{
              fontSize: `${
               lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
              }`,
             }}
            >
             <th
              className={`${lang !== "en" ? "fkp" : "fkp"}`}
              scope="row"
              style={{
               color: `${thirdcolor}`,
               borderTop: "none",
              }}
             >
              7-
             </th>
             <td
              style={{
               lineHeight: "1.3",
               wordSpacing: "2px",
               color: "black",

               fontSize: "23px",
               textAlign: "justify",
               borderTop: "none",
              }}
             >
              If the property is furnished, both parties should count the goods,
              take photos and attach them to the agreement for knowledge before
              renting.
             </td>
            </tr>
            <tr
             style={{
              fontSize: `${
               lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
              }`,
             }}
            >
             <th
              className={`${lang !== "en" ? "fkp" : "fkp"}`}
              scope="row"
              style={{
               color: `${thirdcolor}`,
               borderTop: "none",
              }}
             >
              8-
             </th>
             <td
              style={{
               lineHeight: "1.3",
               wordSpacing: "2px",
               color: "black",

               fontSize: "23px",
               textAlign: "justify",
               borderTop: "none",
              }}
             >
              If the property is furnished, the Second Party should take care of
              the goods and hand them over to the First Party while leaving,
              otherwise, the Second Party is responsible to repair or replace
              the damaged goods at its own expenses.
             </td>
            </tr>
            <tr
             style={{
              fontSize: `${
               lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
              }`,
             }}
            >
             <th
              className={`${lang !== "en" ? "fk" : "fkp"}`}
              style={{
               color: `${thirdcolor}`,
               borderTop: "none",

               fontSize: "20px",
              }}
              scope="row"
             >
              9-
             </th>
             <td
              style={{
               lineHeight: "1.3",
               wordSpacing: "2px",
               color: "black",

               fontSize: "23px",
               textAlign: "justify",
               borderTop: "none",
              }}
             >
              If the residential or commercial unit is furnished, then the
              (DIVINE TIME) Company, by the consent of the First and Second
              parties, calculate the goods in the unit and taking photos, and
              archived with the agreement before renting.
             </td>
            </tr>
            <tr
             style={{
              fontSize: `${
               lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
              }`,
             }}
            >
             <th
              className={`${lang !== "en" ? "fkp" : "fkp"}`}
              scope="row"
              style={{
               color: `${thirdcolor}`,
               borderTop: "none",
              }}
             >
              10-
             </th>
             <td
              style={{
               lineHeight: "1.3",
               wordSpacing: "2px",
               color: "black",

               fontSize: "23px",
               textAlign: "justify",
               borderTop: "none",
              }}
             >
              The First Party must clearance the (government and private of
              project) water and electricity bills before renting the property
              and pay taxes, if there is any, and any other services and
              cleaning of the property before handing over the keys to the
              tenant.
             </td>
            </tr>
            <tr
             style={{
              fontSize: `${
               lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
              }`,
             }}
            >
             <th
              className={`${lang !== "en" ? "fkp" : "fkp"}`}
              scope="row"
              style={{
               color: `${thirdcolor}`,
               borderTop: "none",
              }}
             >
              11-
             </th>
             <td
              style={{
               lineHeight: "1.3",
               wordSpacing: "2px",
               color: "black",

               fontSize: "23px",
               textAlign: "justify",
               borderTop: "none",
              }}
             >
              The Second Party should bear (government and private of project)
              water and electricity bills and all other services during the
              tenancy period and submit all invoices to the (DIVINE TIME
              company), at the end of the tenancy period, the Second Party
              should be paid of water and electricity bills and any other
              services fees.
             </td>
            </tr>
            <tr
             style={{
              fontSize: `${
               lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
              }`,
             }}
            >
             <th
              className={`${lang !== "en" ? "fkp" : "fkp"}`}
              scope="row"
              style={{
               color: `${thirdcolor}`,
               borderTop: "none",
              }}
             >
              12-
             </th>
             <td
              style={{
               lineHeight: "1.3",
               wordSpacing: "4px",
               color: "black",

               fontSize: "22px",
               textAlign: "justify",
               borderTop: "none",
              }}
             >
              The Second Party shall use the property subject to the agreement
              in the manner contracted for commercial or residential purposes,
              otherwise, the Second Party should pay an amount of &nbsp;(
              <NumberFormat
               displayType="text"
               thousandSeparator={true}
               style={{}}
               value={rent_invoice_obj.feelate}
               className="text-center"
               prefix={`${rent_invoice_obj.currency === "dolar" ? "$" : "ID"}`}
              />
              &nbsp;
              {converter3}
              {lang === "en" && rent_invoice_obj.currency === "dolar"
               ? "(USD)"
               : lang === "krd" && rent_invoice_obj.currency === "dolar"
               ? "(دۆلار)"
               : lang === "arb" && rent_invoice_obj.currency === "dolar"
               ? "(دولار)"
               : lang === "en" && rent_invoice_obj.currency !== "dolar"
               ? "(IQD)"
               : lang === "krd" && rent_invoice_obj.currency !== "dolar"
               ? "(دینار)"
               : lang === "arb" && rent_invoice_obj.currency !== "dolar"
               ? "(دینار)"
               : ""}
              )&nbsp;as a fine for each day of violation.
             </td>
            </tr>
            <tr
             style={{
              fontSize: `${
               lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
              }`,
             }}
            >
             <th
              className={`${lang !== "en" ? "fkp" : "fkp"}`}
              scope="row"
              style={{
               color: `${thirdcolor}`,
               borderTop: "none",
              }}
             >
              13-
             </th>
             <td
              style={{
               lineHeight: "1.3",
               wordSpacing: "4px",
               color: "black",

               fontSize: "23px",
               textAlign: "justify",
               borderTop: "none",
              }}
             >
              The Second Party may not rent all or a part of the property except
              with the written consent of the First Party. Otherwise, it is
              considered as a sublet and causes the termination of the agreement
              and the Second Party has no right to compensation.
             </td>
            </tr>

            <tr
             style={{
              fontSize: `${
               lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
              }`,
             }}
            >
             <th
              className={`${lang !== "en" ? "fkp" : "fkp"}`}
              scope="row"
              style={{
               color: `${thirdcolor}`,
               borderTop: "none",
              }}
             >
              14-
             </th>
             <td
              style={{
               lineHeight: "1.3",
               wordSpacing: "4px",
               color: "black",

               fontSize: "23px",
               textAlign: "justify",
               borderTop: "none",
              }}
             >
              The Second Party may not do any changes in the rented property and
              its belongings at all except with the consent of the First Party,
              otherwise, the agreement will be void and the other party will not
              claim for any compensation.
             </td>
            </tr>
            <tr
             style={{
              fontSize: `${
               lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
              }`,
             }}
            >
             <th
              className={`${lang !== "en" ? "fkp" : "fkp"}`}
              scope="row"
              style={{
               color: `${thirdcolor}`,
               borderTop: "none",
              }}
             >
              15-
             </th>
             <td
              style={{
               lineHeight: "1.3",
               wordSpacing: "4px",
               color: "black",

               fontSize: "23px",
               textAlign: "justify",
               borderTop: "none",
              }}
             >
              Our company (DIVINE TIME) will not be responsible for the not
              paying the Second Party's rent, nonetheless, the First Party can
              appeal to the court to take the rights from the Second Party, and
              in case of recourse to the special court, our company will provide
              clarifications to the court when it is necessary after notifying
              it according to the official notice.
             </td>
            </tr>
            <tr
             style={{
              fontSize: `${
               lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
              }`,
             }}
            >
             <th
              className={`${lang !== "en" ? "fkp" : "fkp"}`}
              scope="row"
              style={{
               color: `${thirdcolor}`,
               borderTop: "none",
              }}
             >
              16-
             </th>
             <td
              style={{
               lineHeight: "1.3",
               wordSpacing: "4px",
               color: "black",

               fontSize: "23px",
               textAlign: "justify",
               borderTop: "none",
              }}
             >
              If the First Party sells the property before the expiration of the
              tenancy period, then the Second Party may stay in it until the end
              of the agreement, and the new owner shall be bound by the contents
              of this agreement.
             </td>
            </tr>
           </tbody>
          </table>
         </div>
        </div>
       </div>
       <br />
       <br />
       <br />
       <br />
       <br />
       <br />
       <br />
       <br />
       <div className="conn">
        <div className="row">
         <div className="col-12">
          <table className="table">
           <tbody>
            <tr
             style={{
              fontSize: `${
               lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
              }`,
             }}
            >
             <th
              className={`${lang !== "en" ? "fkp" : "fkp"}`}
              scope="row"
              style={{
               color: `${thirdcolor}`,
               borderTop: "none",
              }}
             >
              17-
             </th>
             <td
              style={{
               lineHeight: "1.3",
               wordSpacing: "4px",
               color: "black",

               fontSize: "23px",
               textAlign: "justify",
               borderTop: "none",
              }}
             >
              Both parties of the contract pay the amount of (50%) of one
              month’s rent to the (DIVINE TIME) company as commission instead of
              bringing both parties together and organizing the contract.
             </td>
            </tr>
            <tr
             style={{
              fontSize: `${
               lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
              }`,
             }}
            >
             <th
              className={`${lang !== "en" ? "fkp" : "fkp"}`}
              scope="row"
              style={{
               color: `${thirdcolor}`,
               borderTop: "none",
              }}
             >
              18-
             </th>
             <td
              style={{
               lineHeight: "1.3",
               wordSpacing: "4px",
               color: "black",

               fontSize: "23px",
               textAlign: "justify",
               borderTop: "none",
              }}
             >
              If the Second Party fails to obtain the permission of the
              concerned party by (
              <Time
               value={rent_invoice_obj.duedate}
               format="YYYY-MM-DD"
               style={{
                fontSize: "22px",
                color: "#000",
               }}
              />
              ), the agreement will be terminated immediately and the Second
              Party will receive the money back.
             </td>
            </tr>
            <tr
             style={{
              fontSize: `${
               lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
              }`,
             }}
            >
             <th
              className={`${lang !== "en" ? "fkp" : "fkp"}`}
              scope="row"
              style={{
               color: `${thirdcolor}`,
               borderTop: "none",
              }}
             >
              19-
             </th>
             <td
              style={{
               lineHeight: "1.3",
               wordSpacing: "4px",
               color: "black",

               fontSize: "23px",
               textAlign: "justify",
               borderTop: "none",
              }}
             >
              The Second Party may not ask for the keys of the property for any
              purpose unless obtaining permission from the relevant authorities
              or security (Asayish) mentioned in the above paragraph and
              stamping of an official stamp on the agreement.
             </td>
            </tr>
            <tr
             style={{
              fontSize: `${
               lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
              }`,
             }}
            >
             <th
              className={`${lang !== "en" ? "fkp" : "fkp"}`}
              scope="row"
              style={{
               color: `${thirdcolor}`,
               borderTop: "none",
              }}
             >
              20-
             </th>
             <td
              style={{
               lineHeight: "1.3",
               wordSpacing: "2px",
               color: "black",

               fontSize: "23px",
               textAlign: "justify",
               borderTop: "none",
              }}
             >
              The Second Party shall be obliged to pay the rent each time in
              full (7) days before the specified date, and if it is late for (7)
              days, the other party shall be liable to the law according to
              Article (17) Paragraph (1) of the Iraqi Tenancy Law No. (87) of
              (1979).
             </td>
            </tr>
            <tr
             style={{
              fontSize: `${
               lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
              }`,
             }}
            >
             <th
              className={`${lang !== "en" ? "fkp" : "fkp"}`}
              scope="row"
              style={{
               color: `${thirdcolor}`,
               borderTop: "none",
              }}
             >
              21-
             </th>
             <td
              style={{
               lineHeight: "1.3",
               wordSpacing: "4px",
               color: "black",

               fontSize: "22px",
               textAlign: "justify",
               borderTop: "none",
              }}
             >
              After the expiration of the agreement, the Second Party should
              oblige to evacuate the property or renew the agreement, otherwise,
              the Second Party will be obliged to pay a daily fine of &nbsp;(
              <NumberFormat
               displayType="text"
               thousandSeparator={true}
               style={{}}
               value={rent_invoice_obj.feelate}
               className="text-center"
               prefix={`${rent_invoice_obj.currency === "dolar" ? "$" : "ID"}`}
              />
              &nbsp;
              {converter3}
              {lang === "en" && rent_invoice_obj.currency === "dolar"
               ? "(USD)"
               : lang === "krd" && rent_invoice_obj.currency === "dolar"
               ? "(دۆلار)"
               : lang === "arb" && rent_invoice_obj.currency === "dolar"
               ? "(دولار)"
               : lang === "en" && rent_invoice_obj.currency !== "dolar"
               ? "(IQD)"
               : lang === "krd" && rent_invoice_obj.currency !== "dolar"
               ? "(دینار)"
               : lang === "arb" && rent_invoice_obj.currency !== "dolar"
               ? "(دینار)"
               : ""}
              )&nbsp;until an agreement is reached or until the property is
              evacuated.
             </td>
            </tr>
            <tr
             style={{
              fontSize: `${
               lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
              }`,
             }}
            >
             <th
              className={`${lang !== "en" ? "fkp" : "fkp"}`}
              scope="row"
              style={{
               color: `${thirdcolor}`,
               borderTop: "none",
              }}
             >
              22-
             </th>
             <td
              style={{
               lineHeight: "1.3",
               wordSpacing: "4px",
               color: "black",

               fontSize: "23px",
               textAlign: "justify",
               borderTop: "none",
              }}
             >
              Both parties agree that all financial transactions in the payment
              and receipt of rent will be carried out through the (DIVINE TIME)
              company.
             </td>
            </tr>

            <tr
             style={{
              fontSize: `${
               lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
              }`,
             }}
            >
             <th
              className={`${lang !== "en" ? "fkp" : "fkp"}`}
              scope="row"
              style={{
               color: `${thirdcolor}`,
               borderTop: "none",
              }}
             >
              23-
             </th>
             <td
              style={{
               lineHeight: "1.3",
               wordSpacing: "2px",
               color: "black",

               fontSize: "23px",
               textAlign: "justify",
               borderTop: "none",
              }}
             >
              After the termination of the contract, if both parties agree to
              renew the contract at the daily price, (DIVINE TIME) Company will
              accomplish a new contract, and both parties of the contract will
              pay an amount of (50%) of one month's rent to the company for the
              following services that are provided by the Company.
              <br />
              1-Assisting and managing all administrative affairs.
              <br />
              2- Contacting the tenant and notifying him when the date of
              receiving the rent is approaching.
              <br />
              3- Receiving the property and handing it over to the land-owner.
              <br />
              4- Assisting the tenant and land-owner to solve any problems and
              damages may occur to the property.
              <br />
              5- If the land-owner of the property is outside Kurdistan Region,
              sending the money will be through the bank and vice versa.
             </td>
            </tr>
           </tbody>
          </table>
         </div>
        </div>
       </div>
       <br /> <br /> <br /> <br /> <br /> <br /> <br /> <br />
       {/* three */}
       <div className="row">
        <div className="col-12">
         <table className="table">
          <tbody>
           <tr
            style={{
             fontSize: `${
              lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
             }`,
            }}
           >
            <th
             className={`${lang !== "en" ? "fkp" : "fkp"}`}
             scope="row"
             style={{
              color: `${thirdcolor}`,
              borderTop: "none",
             }}
            >
             24-
            </th>
            <td
             style={{
              lineHeight: "1.3",
              wordSpacing: "4px",
              color: "black",
              fontSize: "23px",
              textAlign: "justify",
              borderTop: "none",
             }}
            >
             In case of any difference in terms of language or details between
             the language of the agreements, then, the agreement in Kurdish
             language will be the source and relied on it, not Arabic and
             English.
            </td>
           </tr>
           <tr
            style={{
             fontSize: `${
              lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
             }`,
            }}
           >
            <th
             className={`${lang !== "en" ? "fkp" : "fkp"}`}
             scope="row"
             style={{
              color: `${thirdcolor}`,
              borderTop: "none",
             }}
            >
             25-
            </th>
            <td
             style={{
              lineHeight: "1.3",
              wordSpacing: "4px",
              color: "black",
              fontSize: "23px",
              textAlign: "justify",
              borderTop: "none",
             }}
            >
             At the expiration of the agreement, the Second Party may not claim
             refund of the expenses of modifications and changes in any way from
             the First Party after leaving the property.
            </td>
           </tr>
           <tr
            style={{
             fontSize: `${
              lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
             }`,
            }}
           >
            <th
             className={`${lang !== "en" ? "fkp" : "fkp"}`}
             scope="row"
             style={{
              color: `${thirdcolor}`,
              borderTop: "none",
             }}
            >
             26-
            </th>
            <td
             style={{
              lineHeight: "1.3",
              wordSpacing: "4px",
              color: "black",
              fontSize: "23px",
              textAlign: "justify",
              borderTop: "none",
             }}
            >
             (DIVINE TIME) Company is not responsible for any natural disaster
             or any fire or any unwanted incident.
            </td>
           </tr>
           <tr
            style={{
             fontSize: `${
              lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
             }`,
            }}
           >
            <th
             className={`${lang !== "en" ? "fkp" : "fkp"}`}
             scope="row"
             style={{
              color: `${thirdcolor}`,
              borderTop: "none",
             }}
            >
             27-
            </th>
            <td
             style={{
              lineHeight: "1.3",
              wordSpacing: "4px",
              color: "black",
              fontSize: "23px",
              textAlign: "justify",
              borderTop: "none",
             }}
            >
             I, as the tenant, will be obligated to pay the rent as mentioned in
             the points (20th) twentieth and (21st) twenty-first, if I would not
             comply before being notified legally, I agree to suspending the
             (water and electricity) services by the Administration of the
             project.
            </td>
           </tr>
           <tr
            style={{
             fontSize: `${
              lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
             }`,
            }}
           >
            <th
             className={`${lang !== "en" ? "fkp" : "fkp"}`}
             scope="row"
             style={{
              color: `${thirdcolor}`,
              borderTop: "none",
             }}
            >
             28-
            </th>
            <td
             style={{
              lineHeight: "1.3",
              wordSpacing: "4px",
              color: "black",
              fontSize: "23px",
              textAlign: "justify",
              borderTop: "none",
             }}
            >
             The land-owner and tenant must comply with the decision issued by
             Kurdistan Regional Government regarding the exchange of currency
             type from (Dollar) to (Dinar) according to the price of the day on
             which the decision is issued.
            </td>
           </tr>
           <tr
            style={{
             fontSize: `${
              lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
             }`,
            }}
           >
            <th
             className={`${lang !== "en" ? "fkp" : "fkp"}`}
             scope="row"
             style={{
              color: `${thirdcolor}`,
              borderTop: "none",
             }}
            >
             29-
            </th>
            <td
             style={{
              lineHeight: "1.3",
              wordSpacing: "4px",
              color: "black",
              fontSize: "23px",
              textAlign: "justify",
              borderTop: "none",
             }}
            >
             This agreement consists of twenty-nine points and four pages all
             the provisions and points are binding and part of this agreement.
            </td>
           </tr>
          </tbody>
         </table>
        </div>
       </div>
       <div className="form-inline">
        <p
         style={{
          fontSize: "18px",
          color: "black",
          fontWeight: "bold",
          textAlign: "center",
         }}
        >
         {change_Lang("note")}&nbsp;:{rent_invoice_obj.note}
        </p>
       </div>
       <br /> <br />
       <br />
       <br /> <br /> <br />
       <br />
       <br /> <br />
       <br />
       <br /> <br />
       <div className="row">
        <div className="form-group d-flex justify-content-center col-4">
         <label
          style={{
           fontSize: "22px",
           color: "#000",
           fontWeight: "bold",
          }}
          className="form-label"
         >
          First party
         </label>
        </div>
        <div className="col-4">
         <div className="form-group d-flex justify-content-center">
          <label
           style={{
            fontSize: "22px",
            color: "#000",
            fontWeight: "bold",
           }}
           className="form-label"
          >
           Agreement Organizer
          </label>
         </div>
        </div>
        <div className="col-4 d-flex justify-content-center">
         <div className="form-group ">
          <label
           style={{
            fontSize: "22px",
            color: "#000",
            fontWeight: "bold",
           }}
           className="form-label"
          >
           Second party
          </label>
         </div>
        </div>
       </div>
       <div className="row">
        <div className="col-4 form-group d-flex justify-content-center">
         <label
          style={{
           fontSize: "22px",
           color: "#000",
          }}
          className="form-label"
         >
          {rent_invoice_obj.firstname}
         </label>
        </div>
        <div className="col-4">
         <div className="form-group d-flex justify-content-center">
          <label
           style={{
            fontSize: "22px",
            color: "#000",
           }}
           className="form-label"
          >
           {`${rent_invoice_obj.agentId && rent_invoice_obj.agentId.fname} ${
            rent_invoice_obj.agentId && rent_invoice_obj.agentId.lname
           }`}
          </label>
         </div>
        </div>
        <div className="col-4 d-flex justify-content-center">
         <div className="form-group ">
          <label
           style={{
            fontSize: "22px",
            color: "#000",
           }}
           className="form-label"
          >
           {rent_invoice_obj.tenantId && rent_invoice_obj.tenantId.secondname}
          </label>
         </div>
        </div>
       </div>
      </div>
     </div>
    </div>
   </>
  );
 }
}

const mapStateToProps = (state) => {
 return {
  lang: state.HelperReducer.lang,
  rent_invoice_obj: state.InvoiceReducer.rent_invoice_obj,
  index_rentcontrct: state.Invoice_Reducer.index_rentcontrct,
  user: state.AuthReducer.user,
  secondarycolor: state.HelperReducer.secondarycolor,
  thirdcolor: state.HelperReducer.thirdcolor,
  primary_logo: state.HelperReducer.primary_logo,
  footer_logo: state.HelperReducer.footer_logo,
  name_en: state.HelperReducer.name_en,
 };
};

const mapDispatchToProps = (dispatch) => {
 return {
  change_Lang: (key) => dispatch(change_Lang(key)),
 };
};

export default connect(mapStateToProps, mapDispatchToProps)(RentPrintEnglish);
